import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
// import colors from 'vuetify/lib/util/colors'
import { colors as brandColors } from '@/config/config.js'

Vue.use(Vuetify)

export default new Vuetify({
    rtl: true,
    theme: {
        themes: {
            light: {
                primary: brandColors.primary,
				secondary: brandColors.secondary
            }
        }
    }
})
